import { useMemo } from "react";
import { useCurrentWorkflow } from "@/store";
import { extractObjectNamesFromWorkflow, formatObjectNamesPluralized } from "@/utils/workflowUtils";

/**
 * Custom hook to extract and memoize the object name from the current workflow.
 * This avoids duplicate extraction logic across components.
 *
 * @returns Object with:
 *   - objectNames: Array of extracted object names (e.g., ["egg", "car"])
 *   - pluralized: Formatted, pluralized string (e.g., "eggs and cars")
 */
export const useWorkflowObjectName = () => {
    const workflow = useCurrentWorkflow();

    const objectNames = useMemo(
        () => extractObjectNamesFromWorkflow(workflow?.name),
        [workflow?.name]
    );

    const pluralized = useMemo(() => formatObjectNamesPluralized(objectNames), [objectNames]);

    return { objectNames, pluralized };
};
